export default function SearchBar({ value, onChange }) {
  return (
    <div style={styles.wrapper}>
      <div style={styles.inner}>
        {/* Search icon */}
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none"
          stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
 
        <input
          type="text"
          placeholder="Search or start new chat"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          style={styles.input}
        />
 
        {value && (
          <button onClick={() => onChange("")} style={styles.clear}>✕</button>
        )}
      </div>
    </div>
  );
}
 
const styles = {
  wrapper: {
    padding: "8px 12px",
    borderBottom: "1px solid #000000ff",
  },
  inner: {
    display: "flex",
    alignItems: "center",
    gap: 8,
    background: "#404040ff",
    borderRadius: 8,
    padding: "7px 12px",
  },
  input: {
    flex: 1,
    border: "none",
    background: "transparent",
    outline: "none",
    fontSize: 13,
    color: "#1e293b",
  },
  clear: {
    background: "none",
    border: "none",
    cursor: "pointer",
    color: "#94a3b8",
    fontSize: 12,
    padding: 0,
    lineHeight: 1,
  },
};
 